import React, { useEffect, useRef } from 'react';
import './WebProjects.css';
import ProjectCard from './ProjectCard';

import mucho from '../assets/mucho.webp';
import elsa from '../assets/elsa.webp';

import notary from '../assets/notary.webp';

const projects = [
  {
    title: 'Elsa',
    paragraph: 'ELSA ranks on top 10 AI tools thanks to new UI',
    image: mucho,
    backgroundColor: '#e6e5f2',
  },
  {
    title: 'NotaryCam',
    paragraph: 'Generating 1M remote notarization transactions through improved UX/UI',
    image: notary,
    backgroundColor: '#f2faf3',
  },
  {
    title: ' Mucho',
    paragraph: 'Prepping meals with a single tap‍ thanks to UX',
    image: elsa,
    backgroundColor: '#f5ffff',
  },
];

const ProjectsSection = () => {
  const centerCardRef = useRef(null);
  const previousScrollY = useRef(window.scrollY);
  const yOffset = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - previousScrollY.current;
      const direction = deltaY > 0 ? 'down' : 'up';

      if (centerCardRef.current) {
        const change = direction === 'down' ? -1.5 : 1.5;
        let newOffset = yOffset.current + change;
        newOffset = Math.max(-40, Math.min(40, newOffset));
        yOffset.current = newOffset;

        centerCardRef.current.style.transform = `translate3d(0, ${newOffset}px, 0)`;
      }

      previousScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="projects-header">
          <div className="projects-header-left">
            <h2>
              PROJECTS<br />
              <span className="blue-text">SUCCESFULLY DELIVERED</span>
            </h2>
          </div>
          <div className="projects-header-right">
            <p>
              Since 2020, we’ve delivered more than 300 web and software products, in over 15 different industries.
            </p>
          </div>
        </div>

        <div className="project-card-group">
          {projects.map((item, i) => (
            <div
              key={i}
              ref={i === 1 ? centerCardRef : null}
              className="project-card-wrapper"
            >
              <ProjectCard
                title={item.title}
                paragraph={item.paragraph}
                image={item.image}
                backgroundColor={item.backgroundColor}
                isCentered={i === 1}
              />
            </div>
          ))}
        </div>

        
      </div>
    </section>
  );
};

export default ProjectsSection;
